import { PlaceholdersId, TFComponent } from '@types';
import { IntroWizardPlaceholder } from './introWizard';

export const introWizard: TFComponent = {
	component: IntroWizardPlaceholder,
	id: PlaceholdersId.introWizard,
	name: 'introWizard',
};
